import React, { useState } from 'react';
import './DivisionsOverview.css';
import { Link } from 'react-router-dom';

const divisions = [

  {
    title: 'Technology & IT',
    desc: 'Software, AI, cybersecurity, IoT, DevOps, automation & custom tech platforms',
    icon: '💻',
    link: '/techforge',
  },

  //   {
  //   title: 'Education & Training',
  //   desc: 'IT training, soft skills, corporate & vocational upskilling, and EdTech platforms',
  //   icon: '🎓',
  //   link: '/ittech'
  // },

  {
    title: 'Consulting & Recruitment',
    desc: 'Business strategy, HR, career guidance, staffing & facility manpower services',
    icon: '💼',
    link: '/recrutech'
  },

  //   {
  //   title: 'Food & Hospitality',
  //   desc: 'Restaurants, cloud kitchens, catering, food processing, and beverage manufacturing',
  //   icon: '🍽️',
  //   link: '/chococraft'
  // },

  // {
  //   title: 'Pet Care & Animal Welfare',
  //   desc: 'Veterinary services, grooming, pet food, shelters, and pet-tech platforms',
  //   icon: '🐶',
  //   link: '/klyzenpawtner'
  // },

  {
    title: 'Media, Entertainment & Production',
    desc: 'Film production, OTT, music, web series, podcasting, event & ad campaigns',
    icon: '🎬',
    link: '/klyzenproduction'
  },

  
  {
    title: 'Industrial & Manufacturing',
    desc: 'EV components, garments, construction materials, machinery, and automation',
    icon: '🏭',
  },
  {
    title: 'Health & Wellness',
    desc: 'Clinics, telemedicine, fitness, supplements, diagnostics, and health apps',
    icon: '❤️',
  },

  {
    title: 'Logistics, Transport & Travel',
    desc: 'Smart logistics, supply chain, fleet management, and travel tech solutions',
    icon: '🚚',
  },
  {
    title: 'Finance, Real Estate & Investments',
    desc: 'FinTech, trading, real estate, investments, and venture capital services',
    icon: '💰',
  },
  {
    title: 'Agriculture & Environment',
    desc: 'Agri-tech, organic farming, renewable energy, and eco-product innovation',
    icon: '🌿',
  },
 
  
];

function DivisionsOverview() {
  const [showAll, setShowAll] = useState(false);
  const displayedDivisions = showAll ? divisions : divisions.slice(0, 7);

  return (
    <section className="divisions-section" id="services">
      <h2>Our Industries & Divisions</h2>
      <p className="section-subtitle">
        Operating across 25+ sectors to build a connected and innovative future.
      </p>

      <div className="divisions-grid">
        {displayedDivisions.map(({ title, desc, icon, link }, idx) => (
          <Link
            to={link || '#'}
            key={idx}
            className="division-card"
            tabIndex="0"
          >
            <div className="division-icon">{icon}</div>
            <h3>{title}</h3>
            <p>{desc}</p>
            <div className="learn-more">Learn More →</div>
          </Link>
        ))}
      </div>

      <div className="show-more-wrapper">
        <button
          className="show-more-btn"
          onClick={() => setShowAll(!showAll)}
        >
          {showAll ? 'Show Less ▲' : 'Show More ▼'}
        </button>
      </div>
    </section>
  );
}

export default DivisionsOverview;